import React, { ReactElement } from "react";

import classNames from "classnames";

import { IconChat } from "../icons/IconChat";
import { ChatGreetingProps } from "./ChatGreeting.types";

export const ChatGreeting = ({
  className,
  userName,
  agentName = "Agent Name",
  agentFullName = "Your Intelligence Agent",
  bodyText = "Pick a popular task below or ask your own question.",
  isFullScreen,
  ...rest
}: ChatGreetingProps): ReactElement => {
  return (
    <div
      className={classNames("spark-mar-b-2", className)}
      style={{
        textAlign: "center",
        marginBottom: isFullScreen ? 40 : 0,
      }}
      {...rest}
    >
      <IconChat className="spark-mar-b-.5" data-testid="icon-chat" />
      <h2 style={!isFullScreen ? { fontSize: 25 } : {}}>
        Hello{userName ? ` ${userName}` : ""}! I&apos;m {agentName}
        <br />
        {agentFullName}
      </h2>
      <p>{bodyText}</p>
    </div>
  );
};
